import { Button } from '@material-ui/core';
import styled from 'styled-components';
import colors from '../../../styles/settings/colors';
import fontSize from '../../../styles/settings/fontSize';

export const TableTitleHeader = styled.div`
  align-items: center;
  background-color: ${colors.sanMarino};
  border-radius: 4px 4px 0 0;
  color: #fff;
  display: flex;
  flex-flow: row wrap;
  font-size: ${fontSize.button};
  justify-content: space-between;
  margin: 0 0 4px;
  overflow: hidden !important;
  border-top-right-radius: 11px;
  border-top-left-radius: 11px;
  h1 {
    font-family: 'Segoe UI';
    text-align: center;
    font-weight: bold;
    margin: 0 auto;
    padding: 2px 4px;
  }
`;

export const RefuseContainer = styled.div`
  margin: 8px 0;
  border: solid 1px #000;
  border-radius: 15px;
  margin-top: 10px;
  h1 {
    font-family: 'Segoe UI';
    text-align: center;
    font-weight: bold;
    margin: 0 auto;
    padding: 2px 4px;
  }
  
  .MuiInputBase-root {
    width: 100%;
  }
  .input-paper {
    border: 1px solid ${colors.sanMarino};
    height: 42px;
  }

  .input-select {
    color: #949494;
    height: 44px;
    text-transform: uppercase;
    padding: 8px;
  }
`;

export const InputLabel = styled.label`
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 7px;
`;

export const ConfirmationBox = styled.div`
  max-width: 400px;
  margin: 16px 0;
  width: 100%;

  .confirmation-message {
    display: block;
    font-weight: bold;
    font-family: 'Roboto', sans-serif;
    font-size: 23px;
    margin: 0 0 10px;
  }

  .confirmation-box {
    display: flex;
    flex-flow: row nowrap;
    width: 300px !important;

    input:first-child {
      margin: 0 8px 0 0;
    }

    input {
      background-color: ${colors.sanMarino};
      border-radius: 8px;
      color: #fff;
      font-family: 'Roboto', sans-serif;
      margin: 0 8px;
    }
  }

  button {
    font-family: 'Roboto', sans-serif;
    margin: 8px 0;
    width: calc(100% - 122px);

    &.Mui-disabled {
      background-color: rgb(35 45 100 / 90%) !important;
      cursor: not-allowed !important;
    }
  }
  .MuiFormControl-root {
    width 95%;
  }
`;

export const ActionButton = styled(Button)`
  background-color: ${colors.sanMarino}!important;
  color: ${colors.white}!important;
  font-size: 13px !important;
  min-width: 200px !important;
`;

export const InfoContainer = styled.div`
  border: solid 1px #000;
  border-radius: 15px;
  margin-top: 10px;
`

export const InfoTitle = styled.div`
  font-family: 'Segoe UI';
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin: 0 auto;
  padding: 2px 4px;
`
export const ErrorMessage = styled.span`
  color: ${colors.tundora};
`;
